import * as api from "@/api/williams/testEvents";
import { queryKeys } from "../../queryKeys";
import { TestEvent } from "@/api/williams/testEvents";
import { useMutation, useQueryClient } from "react-query";

export function useCancelTestEvent() {
  const queryClient = useQueryClient();

  return useMutation(async (event: TestEvent) => {
    const data = await api.cancelTestEvent(event);
    const updatedEvent = {
      ...data,
      testEventDate: data.testEventDate?.substring(0, 10),
    };

    queryClient.setQueryData(queryKeys.testEvent.single(event.id), updatedEvent);
    queryClient.invalidateQueries(queryKeys.scopeOfWork.list());

    return updatedEvent;
  });
}
